import { useCallback, useState, useContext } from "react";
import useApi from "./useApi";
import useModal from "./useModal";
import { getReportList } from "apis/generate-report.api";
import { UserContext } from "contexts";

const useExport = ({ api, reportType, mappedFilterState }) => {
  const { request } = useApi({ api, params: api.params });
  const { request: fetchLatestReport } = useApi({ api: getReportList, handleOwnError: true });
  const { user } = useContext(UserContext);
  const [loading, setLoading] = useState(false);
  const downloadProgressModal = useModal();

  const exportReport = useCallback(
    async ({ fileType } = {}) => {
      const filterState = {
        ...mappedFilterState,
        ...(fileType ? { fileType } : {}),
        connectionId: localStorage.getItem("connectionId"),
      };
      delete filterState.page;
      delete filterState.perPage;

      try {
        setLoading(true);
        await request({ ...filterState, reportType });
        setTimeout(async () => {
          try {
            const res = await fetchLatestReport({
              page: 1,
              perPage: 1,
              orderBy: "createdAt",
              order: "desc",
              userId: user?.userId,
              reportTypes: reportType,
            });
            const latest = res?.reports?.[0];
            if (latest?.fileUrl) {
              window.open(latest?.fileUrl, "_blank");
            }
          } finally {
            setLoading(false);
            downloadProgressModal.show();
          }
        }, 3000);
      } catch {
        setLoading(false);
        downloadProgressModal.show();
      }
    },
    [request, reportType, mappedFilterState, fetchLatestReport, user, downloadProgressModal],
  );

  return { exportReport, exporting: loading, downloadProgressModal };
};

export default useExport;
